<template>
  <div class="">
    <m-wish-list-wrapper :user_id="user_id">
      <template v-slot="{wishListItems,removeItem,pagination,changePageFunction}">
        <div class="">

          <table class="table">
            <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">نام</th>
              <th scope="col">عملیات</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in wishListItems">
              <th>{{ item.id }}</th>
              <td>
                <m-a :href="{name:'Product',params:{name:item.itemable.link}}">
                  {{ item.itemable.name }}
                </m-a>
              </td>
              <td>
                <span class="btn btn-danger" @click="removeItem(item)">حذف</span>
              </td>
            </tr>
            </tbody>
          </table>

          <div class="col-12">
            <div class="row justify-content-center">
              <m-paginate1 :meta="pagination" :on-change-page="changePageFunction"/>
            </div>
          </div>

        </div>
      </template>
    </m-wish-list-wrapper>
  </div>
</template>

<script>
import {defineComponent} from 'vue'
import mWishListWrapper from "../../Wrappers/WishListWrapper.vue";
import mA from '../../Tags/A.vue'
import mPaginate1 from "../../Pagination/Paginate1.vue";

export default defineComponent({
  name: "WishListArchive1",
  components: {mPaginate1, mWishListWrapper, mA},
  props: {
    user_id: {
      default: null
    }
  },
  methods: {}
})
</script>

<style scoped>

</style>